import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import './cube-ui'
import './driver-biz-ui'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { init } from '@didi/driver-biz-sdk'
import router from './router'
import pinia from './pinia'
import './composition-api'

import { hideCornerButtonMore } from '@/common/biz/corner-button'
import { env } from '@didi/utils'
if (env.rainbow) {
  hideCornerButtonMore()
}

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
  pinia
}).$mount('#app')
